<script setup>
import { computed, useSlots } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const slots = useSlots()

const hasTitleSlot = computed(() => slots.title && !!slots.title())
const hasDefaultSlot = computed(() => slots.default && !!slots.default())
</script>
<template>
  <div v-if="hasTitleSlot" class="flex items-center justify-center my-2">
    <h1 class="text-xl"><slot name="title" /></h1>
  </div>
  <hr v-if="hasTitleSlot" class="border-t dark:border-slate-800 border-gray-100" />
  <div class="text-center py-24 text-gray-500 dark:text-slate-400">
    <template v-if="hasDefaultSlot">
      <slot name="default" />
    </template>
    <p v-else>{{ t("Nothing's here…") }}</p>
  </div>
</template>
